<template>
  <el-tooltip :content="$t('topUp.reduceRetries.btnTooltip')"
              effect="light"
              :open-delay="300"
              placement="bottom">
    <base-button type="primary" class="m-0" @click.native="handleReduceTopUpRetries()" :loading="updating" :disabled="!enabled">
      <i class="tim-icons icon-alert-circle-exc pr-2"/> {{ $t('topUp.reduceRetries.btnLbl') }}
    </base-button>
  </el-tooltip>
</template>

<script>
import {mapActions, mapState} from "vuex";
import swal from "sweetalert2";

export default {
  name: "ResetTopUpRetriesBtn",
  props: {
    accountId: {
      type: String,
      required: true
    },
    topUpId: {
      type: String,
      required: true
    },
    enabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState({
      updating: state => state.account_top_up.updating,
      error: state => state.account_top_up.error,
    }),
  },
  methods: {
    ...mapActions(['ReduceAccountTopUpRetries', 'LoadAccountTopUp']),
    handleReduceTopUpRetries() {
      swal({
        title: this.$t('topUp.reduceRetries.text'),
        text: `'${this.topUpId}'`,
        confirmButtonText: this.$t('topUp.reduceRetries.actionBtnLabel'),
        cancelButtonText: this.$t('topUp.reduceRetries.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-primary',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.ReduceAccountTopUpRetries({accountID: this.accountId, topUpID: this.topUpId}).then(() => {
            if (this.error == null) {
              this.LoadAccountTopUp({accountID: this.accountId, topUpID: this.topUpId})
              this.$notify({
                type: 'success',
                message: this.$t('topUp.reduceRetries.succeededNotification', {
                  topUpId: this.topUpId
                }),
                icon: 'tim-icons icon-alert-circle-exc'
              })
            }

          })
        }
      });
    },
  }
}
</script>
